import Folder from "@mapmycustomers/shared/types/entity/Folder";

/**
 * Walks the parentFolderId chain from the given folder up to the root.
 * Returns ancestors ordered from root to immediate parent (for breadcrumb display).
 */
const getAncestors = (
  folderId: Folder["id"],
  folders: Folder[],
  map?: Map<Folder["id"], Folder>
): Folder[] => {
  const folderMap = map ? map : new Map(folders.map((folder) => [folder.id, folder]));

  const ancestors: Folder[] = [];
  let current = folderMap.get(folderId);

  while (current && current.parentFolderId != null) {
    const parent = folderMap.get(current.parentFolderId);
    if (!parent) {
      break;
    }
    ancestors.unshift(parent);
    current = parent;
  }

  return ancestors;
};

export default getAncestors;
